import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const Firebolt = ({ height = 24, width = 24, ...props }: SvgIconProps) => (
  <SvgIcon
    data-test="Firebolt"
    height={height}
    width={width}
    title="Firebolt logo"
    titleId="firebolt-logo-title"
    viewBox="0 0 128 128"
    {...props}
  >
    <path
      d="M3 58L24 58.0315L1 1C1 1 42.3364 1 64 1C98.7939 1 127 29.2061 127 64C127 98.7939 98.7939 127 64 127C57.2863 127 30.1789 127 30.1789 127L3 58Z"
      fill="#F72A30"
    />
    <path
      d="M65.024 43.7364V57.2594C65.024 57.6687 65.3836 58 65.8232 58H84.1879C84.6275 58 84.9871 58.3313 84.9871 58.7406V72.2837C84.9871 72.693 84.6275 73.0244 84.1879 73.0244H65.8132C65.3736 73.0244 65.014 73.3557 65.014 73.765V102.259C65.014 102.669 64.6543 103 64.2148 103H49.7992C49.3596 103 49 102.669 49 102.259V28.7406C49 28.3313 49.3596 28 49.7992 28H88.2008C88.6404 28 89 28.3313 89 28.7406V42.2551C89 42.6644 88.6404 42.9957 88.2008 42.9957H65.8232C65.3736 42.9957 65.024 43.3271 65.024 43.7364Z"
      fill="white"
    />
    <path
      d="M65.024 43.7364V57.2594C65.024 57.6687 65.3836 58 65.8232 58H84.1879C84.6275 58 84.9871 58.3313 84.9871 58.7406V72.2837C84.9871 72.693 84.6275 73.0244 84.1879 73.0244H65.8132C65.3736 73.0244 65.014 73.3557 65.014 73.765V102.259C65.014 102.669 64.6543 103 64.2148 103H49.7992C49.3596 103 49 102.669 49 102.259V28.7406C49 28.3313 49.3596 28 49.7992 28H88.2008C88.6404 28 89 28.3313 89 28.7406V42.2551C89 42.6644 88.6404 42.9957 88.2008 42.9957H65.8232C65.3736 42.9957 65.024 43.3271 65.024 43.7364Z"
      fill="url(#paint0_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="69"
        y1="28"
        x2="69"
        y2="103"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </SvgIcon>
);
